interface Links {
  moreInfo: Record<string, string>;
  changeOpinionLink: Record<string, string>;
}

export default {
  moreInfo: {
    FR:
      'https://www.ovhcloud.com/fr/terms-and-conditions/cookies-policy/',

    GB: 'https://www.ovhcloud.com/en-gb/terms-and-conditions/cookies-policy/',
    IE: 'https://www.ovhcloud.com/en-ie/terms-and-conditions/cookies-policy/',
    DE: 'https://www.ovhcloud.com/de/terms-and-conditions/cookies-policy/',
    ES: 'https://www.ovhcloud.com/es-es/terms-and-conditions/cookies-policy/',
    IT: 'https://www.ovhcloud.com/it/terms-and-conditions/cookies-policy/',
    NL: 'https://www.ovhcloud.com/nl/terms-and-conditions/cookies-policy/',
    PL: 'https://www.ovhcloud.com/pl/terms-and-conditions/cookies-policy/',
    PT: 'https://www.ovhcloud.com/pt/terms-and-conditions/cookies-policy/',
    SN: 'https://www.ovhcloud.com/fr-sn/terms-and-conditions/cookies-policy/',
    TN:
      'https://www.ovhcloud.com/fr-tn/terms-and-conditions/cookies-policy/',
    MA:
      'https://www.ovhcloud.com/fr-ma/terms-and-conditions/cookies-policy/',
    QC: 'https://www.ovhcloud.com/fr-ca/terms-and-conditions/cookies-policy/',
    CA: 'https://www.ovhcloud.com/en-ca/terms-and-conditions/cookies-policy/',
    WE: 'https://www.ovhcloud.com/en/terms-and-conditions/cookies-policy/',
    WS:
      'https://www.ovhcloud.com/es/terms-and-conditions/cookies-policy/',
    AU: 'https://www.ovhcloud.com/en-au/terms-and-conditions/cookies-policy/',
    SG: 'https://www.ovhcloud.com/en-sg/terms-and-conditions/cookies-policy/',
    ASIA: 'https://www.ovhcloud.com/asia/terms-and-conditions/cookies-policy/',
    IN: 'https://www.ovhcloud.com/en-in/terms-and-conditions/cookies-policy/',
  },
  changeOpinionLink: {
    FR:
      'https://www.ovh.com/fr/protection-donnees-personnelles/exercer-vos-droits/',
    GB: 'https://www.ovh.co.uk/personal-data-protection/exercise-your-rights/',
    IE: 'https://www.ovh.ie/personal-data-protection/exercising-your-rights/',
    DE: 'https://www.ovh.de/schutz-personenbezogener-daten/rechte-ausueben/',
    ES: 'https://www.ovh.es/proteccion-datos-personales/ejercer-derechos/',
    IT: 'https://www.ovh.it/protezione-dati-personali/esercita-i-tuoi-diritti/',
    NL:
      'https://www.ovh.nl/beveiliging-persoonlijke-data/uw-rechten-uitoefenen/',
    PL: 'https://www.ovh.pl/ochrona-danych-osobowych/korzystanie-z-praw/',
    PT: 'https://www.ovh.pt/proteger-dados-pessoais/exercer-seus-direitos/',
    TN:
      'https://www.ovh.com/tn/protection-donnees-personnelles/exercer-vos-droits/',
  },
} as Links;
